import React, { useState } from "react";
import Axios from "../../axios/axios";
import imageCompression from "browser-image-compression";
import { Link, useNavigate } from "react-router-dom";
// import { toast } from 'react-toastify';
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import AlertModal from "../../actions/AlertModal";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import "./login.css";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export default function SignUp() {
  const [uploading, setUploading] = useState(false);
  const [image, setImage] = useState(null);
  const [cName, setCName] = useState("");
  const [cEmail, setCEmail] = useState("");
  const [cPassword, setCPassword] = useState("");
  const [cAddress, setCAddress] = useState("");
  const [cNumber, setCNumber] = useState("");
  const [cGstNumber, setCGstNumber] = useState("");
  const [cBalance, setCBalance] = useState(0);
  const [cStatus, setCstatus] = useState("");
  const [cUsername, setCUsername] = useState("");
  const [cPinCode, setCPinCode] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [cbank, setCbankName] = useState("");
  const [cbankAddress, setCbankAddress] = useState("");
  const [cAccountNo, setCaccountno] = useState("");
  const [cCurrency, setCcurrency] = useState("");
  const [ciban, setCiban] = useState("");
  const [cswift, setCswift] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [activeLabels, setActiveLabels] = useState(
    Array(3).fill(false) // Assuming 17 steps
  );

  const totalSteps = 3;

  // Function to handle next button click
  const handleNext = () => {
    const newErrors = {};

    if (currentStep === 1) {
      if (!cName.trim()) newErrors.cName = "Please fill this field";
      if (!cEmail.trim()) {
        newErrors.cEmail = "Please fill this field";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cEmail)) {
        newErrors.cEmail = "Enter a valid email format";
      }

      if (!cNumber.trim()) {
        newErrors.cNumber = "Please fill this field";
      } else if (!/^\d{10}$/.test(cNumber)) {
        newErrors.cNumber = "Phone number must be 10 digits";
      }
    }

    if (currentStep === 3) {
      if (!cUsername.trim()) newErrors.cUsername = "Please fill this field";
      if (cPassword !== confirmPassword) {
        newErrors.cPassword = "Passwords do not match";
        newErrors.confirmPassword = "Passwords do not match";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Function to handle previous button click
  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  // Function to update label color when a label is clicked
  const handleLabelClick = (index) => {
    setActiveLabels((prev) => {
      const newLabels = [...prev];
      newLabels[index] = !newLabels[index]; // Toggle the label color state
      return newLabels;
    });
  };

  // Function to set progress bar width
  const setProgressBar = () => {
    const percent = (100 / totalSteps) * currentStep;
    return `${percent}%`;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Final validation before submit
    const newErrors = {};
    if (!cUsername.trim()) newErrors.cUsername = "Please fill this field";
    if (!cPassword.trim()) newErrors.cPassword = "Please fill this field";
    if (cPassword !== confirmPassword) {
      newErrors.cPassword = "Passwords do not match";
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }

    try {
      const data = {
        customerName: cName,
        username: cUsername,
        email: cEmail,
        password: cPassword,
        address: cAddress,
        phoneNumber: cNumber,
        gstNumber: cGstNumber,
        accountStatus: cStatus,
        photo: image,
        balance: cBalance,
        bankName: cbank,
        bankAddress: cbankAddress,
        accountNumber: cAccountNo,
        currency: cCurrency,
        ibanNumber: ciban,
        swift: cswift,
        country,
        pincode: cPinCode,
        city,
        state,
        accountStatus,
      };

      const response = await Axios.post(`/customer/register`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      showAlert("Customer created successfully!");
      setTimeout(() => navigate("/login"), 1000);
    } catch (error) {
      console.error(
        "Error creating customer:",
        error.response || error.message
      );
      const message =
        error?.response?.data?.message ||
        "An error occurred during registration.";
      showAlert(message);
    } finally {
      setLoading(false);
    }
  };

  const uploadFileHandler = async (e, val) => {
    console.log("uploading");
    const file = e.target.files[0];

    // Set up image compression options
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    console.log(file);
    try {
      // Compress the image
      const compressedFile = await imageCompression(file, options);
      console.log(compressedFile, "compressedFile");
      const formData = new FormData();
      formData.append("images", compressedFile);
      setUploading(true);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const { data } = await Axios.post("/upload-multiple", formData, config);
      console.log(data, "upload data");
      setLoading(false);
      setUploading(false);

      if (val === "photo") {
        setImage({
          title: file.name,
          url: data.fileUrls[0], // Assuming backend returns an array of URLs
        });
      }
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const showAlert = (message) => {
    setAlertMessage(message);
    setIsAlertOpen(true);
  };

  return (
    <div className="Main-div">
      <TopNavBar />
      <div className="TopSearchBar">
        <TopSearchBar />
      </div>
      <div class="container signupForm">
        <div class="row justify-content-center">
          <div class="col-10 col-sm-9 col-md-7 col-lg-6 col-xl-6 text-center p-0 mb-2">
            <div class=" px-0 pt-4 pb-0  mb-3">
              <div className="text-center mt-3">
                <p>
                  Are you a supplier?
                  <Link to="/signup-supplier" className="text-primary ms-1">
                    Sign up as a supplier instead
                  </Link>
                </p>
              </div>
              <h3>SIGNUP </h3>
              <p>
                From its medieval origins to the digital era, learn everything
                there is to know about the ubiquitous lorem ipsum passage.
              </p>
              <form id="msform">
                <ul id="progressbar">
                  {Array.from({ length: totalSteps }, (_, index) => (
                    <li
                      key={index}
                      className={currentStep > index + 1 ? "active" : ""}
                    >
                      <span
                        style={{
                          color: activeLabels[index] ? "#0090F8" : "#1D1D1D",
                        }}
                        onClick={() => handleLabelClick(index)}
                      >
                        <span className="lightGrey"> Step {index + 1}</span>
                        <br />
                        <span className="stepHead">
                          {" "}
                          {index == 0
                            ? "Contact Information"
                            : index == 1
                            ? "Customer Information"
                            : "Account Settings"}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
                {/* Progress bar indicator */}
                <div
                  className="progress-bar"
                  style={{ width: setProgressBar() }}
                />
                {/* Fieldset containers */}
                <div className="fieldsets">
                  {Array.from({ length: totalSteps }, (_, index) => (
                    <fieldset
                      key={index}
                      style={{
                        display: currentStep === index + 1 ? "block" : "none",
                        opacity: currentStep === index + 1 ? 1 : 0,
                      }}
                    >
                      <div>
                        <fieldset>
                          {/* Step 1 */}
                          {index === 0 && (
                            <div
                              class="form-card"
                              style={{ marginTop: "20px" }}
                            >
                              <div class="row mt_20">
                                <div class="col-md-6">
                                  {/* <div class="form_Content">
                                    <label class="customer">Customer*</label>
                                  </div> */}
                                  {/* <div class="row formRadioBtn d-flex justify-content-start">
                                    <div class="d-flex flex-row bd-highlight mb-3">
                                      <div class="p-2 bd-highlight">
                                        <div class="form-check form-check-inline">
                                          <input
                                            class="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault1"
                                          />
                                          <label
                                            class="form-check-label"
                                            for="flexRadioDefault1"
                                          >
                                            Legal entity
                                          </label>
                                        </div>
                                      </div>
                                      <div class="p-2 bd-highlight">
                                        <div class="form-check form-check-inline">
                                          <input
                                            class="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault2"
                                          />
                                          <label
                                            class="form-check-label"
                                            for="flexRadioDefault2"
                                          >
                                            Private person
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                                </div>

                                <div class="col-md-6"></div>
                              </div>

                              <div class="row mt_20">
                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel1">
                                      Customer Name*
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control ${
                                        errors.cName ? "is-invalid" : ""
                                      }`}
                                      placeholder="Enter your Full Name"
                                      value={cName}
                                      onChange={(e) => {
                                        setCName(e.target.value);
                                        setErrors((prev) => ({
                                          ...prev,
                                          cName: "",
                                        }));
                                      }}
                                    />
                                    {errors.cName && (
                                      <div className="text-danger">
                                        {errors.cName}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div class="col-md-6 form_Content"></div>
                              </div>

                              <div class="row mt_20">
                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <div>
                                      <label for="inputName" id="namelabel3">
                                        Email id*{" "}
                                      </label>
                                    </div>
                                    <input
                                      type="email"
                                      className={`form-control ${
                                        errors.cEmail ? "is-invalid" : ""
                                      }`}
                                      placeholder="Email"
                                      value={cEmail}
                                      onChange={(e) => {
                                        setCEmail(e.target.value);
                                        setErrors((prev) => ({
                                          ...prev,
                                          cEmail: "",
                                        }));
                                      }}
                                    />
                                    {errors.cEmail && (
                                      <div className="text-danger">
                                        {errors.cEmail}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel4">
                                      Phone Number*
                                    </label>
                                    <div class="row">
                                      <div class="form-group col-sm-4 formMobileNumber">
                                        <select
                                          class="form-control selectDropDown"
                                          id=""
                                          required
                                        >
                                          <option>+91</option>
                                          <option>+97</option>
                                          <option>+698</option>
                                          <option>4</option>
                                          <option>5</option>
                                        </select>
                                      </div>
                                      <div class="form-group col-sm-8 formMobileNumber">
                                        <input
                                          type="text"
                                          className={`form-control ${
                                            errors.cNumber ? "is-invalid" : ""
                                          }`}
                                          value={cNumber}
                                          onChange={(e) => {
                                            setCNumber(e.target.value);
                                            setErrors((prev) => ({
                                              ...prev,
                                              cNumber: "",
                                            }));
                                          }}
                                          placeholder="Mobile number"
                                        />
                                        {errors.cNumber && (
                                          <div className="text-danger">
                                            {errors.cNumber}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row mt_20">
                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel5">
                                      GST Number{" "}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={cGstNumber}
                                      onChange={(e) =>
                                        setCGstNumber(e.target.value)
                                      }
                                      id="inputlabel5"
                                      aria-describedby="emailHelp"
                                      placeholder=" GST Number	"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 form_Content">
                                  {/* <div class="form-group ">
                                    <label for="inputName" id="namelabel5">
                                      Balance{' '}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={cBalance}
                                      onChange={(e) =>
                                        setCBalance(e.target.value)
                                      }
                                      id="inputlabel5"
                                      aria-describedby="emailHelp"
                                      placeholder=" Balance	"
                                    />
                                  </div> */}
                                  <div className="form-group">
                                    <label htmlFor="exampleInputPriority4">
                                      Image
                                    </label>
                                    <input
                                      type="file"
                                      className="form-control"
                                      onChange={(e) =>
                                        uploadFileHandler(e, "photo")
                                      }
                                    />

                                    {uploading ? (
                                      <div
                                        className="spinner-border"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    ) : (
                                      image && (
                                        <img
                                          src={
                                            image ||
                                            process.env.PUBLIC_URL +
                                              "/images/select_image.png"
                                          }
                                          alt="Uploaded Preview"
                                          height="100"
                                        />
                                      )
                                    )}
                                  </div>
                                </div>
                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel7">
                                      {" "}
                                      Address{" "}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={cAddress}
                                      onChange={(e) =>
                                        setCAddress(e.target.value)
                                      }
                                      id="inputlabel7"
                                      aria-describedby="emailHelp"
                                      placeholder=" Address 	"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel5">
                                      Country{" "}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={country}
                                      onChange={(e) =>
                                        setCountry(e.target.value)
                                      }
                                      id="inputlabel5"
                                      aria-describedby="emailHelp"
                                      placeholder=" Country	"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel5">
                                      State{" "}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={state}
                                      onChange={(e) => setState(e.target.value)}
                                      id="inputlabel5"
                                      aria-describedby="emailHelp"
                                      placeholder=" State	"
                                    />
                                  </div>
                                </div>

                                <div class="col-md-6 form_Content">
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel5">
                                      City{" "}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={city}
                                      onChange={(e) => setCity(e.target.value)}
                                      id="inputlabel5"
                                      aria-describedby="emailHelp"
                                      placeholder=" City	"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div class="row mt_20">
                                <div class="col-md-6 form_Content">
                                  {/* <div class="form-group ">
                                    <label for="inputName" id="namelabel5">
                                      City{' '}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                       value={city}
                                       onChange={(e) =>
                                         setCity(e.target.value)
                                       }
                                      id="inputlabel5"
                                      aria-describedby="emailHelp"
                                      placeholder=" City	"
                                    />
                                  </div> */}
                                  <div class="form-group ">
                                    <label for="inputName" id="namelabel5">
                                      PIN*{" "}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={cPinCode}
                                      onChange={(e) =>
                                        setCPinCode(e.target.value)
                                      }
                                      id="inputlabel5"
                                      aria-describedby="emailHelp"
                                      placeholder=" PIN	"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6 form_Content"></div>
                              </div>
                            </div>
                          )}
                        </fieldset>

                        {index === 1 && (
                          <div class="form-card">
                            <div class="row mt_20">
                              <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel12">
                                    Account Number{" "}
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="inputlabel2"
                                    aria-describedby="emailHelp"
                                    placeholder="Account Number	"
                                    value={cAccountNo}
                                    onChange={(e) =>
                                      setCaccountno(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              {/* <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel12">
                                    Preferable type of delivery*
                                  </label>
                                  <div class="form-group">
                                    <select
                                      class="form-control selectDropDown"
                                      id="inputlabel12"
                                    >
                                      <option>Select</option>
                                      <option>one</option>
                                      <option>two</option>
                                      <option>three</option>
                                      <option>ten</option>
                                    </select>
                                  </div>
                                </div>
                              </div> */}
                              <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel17">
                                    Bank Name{" "}
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="inputlabel17"
                                    aria-describedby="emailHelp"
                                    placeholder="Bank Name	"
                                    value={cbank}
                                    onChange={(e) =>
                                      setCbankName(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="row mt_20">
                              {/* <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel13">
                                    Preferable type of payment*
                                  </label>
                                  <div class="form-group">
                                    <select
                                      class="form-control selectDropDown"
                                      id="inputlabel13"
                                    >
                                      <option>Select</option>
                                      <option>one</option>
                                      <option>two</option>
                                      <option>three</option>
                                      <option>ten</option>
                                    </select>
                                  </div>
                                </div>
                              </div> */}

                              <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel18">
                                    Bank Address{" "}
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="inputlabel18"
                                    aria-describedby="emailHelp"
                                    placeholder="Bank Address	"
                                    value={cbankAddress}
                                    onChange={(e) =>
                                      setCbankAddress(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              {/* <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel14">
                                    {' '}
                                    Parameter of subscription*{' '}
                                  </label>
                                  <div class="form-group">
                                    <select
                                      class="form-control selectDropDown"
                                      id="inputlabel14"
                                    >
                                      <option>Select</option>
                                      <option>one</option>
                                      <option>two</option>
                                      <option>three</option>
                                      <option>ten</option>
                                    </select>
                                  </div>
                                </div>
                              </div> */}

                              <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel19">
                                    IBAN Number{" "}
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="inputlabel19"
                                    aria-describedby="emailHelp"
                                    placeholder="IBAN Number"
                                    value={ciban}
                                    onChange={(e) => setCiban(e.target.value)}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="row mt_20">
                              <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel20">
                                    Currency{" "}
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="inputlabel20"
                                    aria-describedby="emailHelp"
                                    placeholder="Currency	"
                                    value={cCurrency}
                                    onChange={(e) =>
                                      setCcurrency(e.target.value)
                                    }
                                  />
                                </div>
                              </div>

                              <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel21">
                                    Swift Number{" "}
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="inputlabel21"
                                    aria-describedby="emailHelp"
                                    placeholder="Swift Number	"
                                    value={cswift}
                                    onChange={(e) => setCswift(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {index === 2 && (
                          <div class="form-card">
                            <div class="row mt_20">
                              <div class="col-md-6 form_Content">
                                <div className="form-group">
                                  <label htmlFor="username">Username*</label>
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      errors.cUsername ? "is-invalid" : ""
                                    }`}
                                    value={cUsername}
                                    onChange={(e) => {
                                      setCUsername(e.target.value);
                                      setErrors((prev) => ({
                                        ...prev,
                                        cUsername: "",
                                      }));
                                    }}
                                    placeholder="Username"
                                  />
                                  {errors.cUsername && (
                                    <div className="text-danger">
                                      {errors.cUsername}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-md-6 form_Content">
                                <div class="form-group ">
                                  <label for="inputName" id="namelabel23">
                                    Password*
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    id="inputlabel23"
                                    aria-describedby="emailHelp"
                                    placeholder="Enter your password"
                                    value={cPassword}
                                    onChange={(e) =>
                                      setCPassword(e.target.value)
                                    }
                                    required
                                  />
                                  {errors.cPassword && (
                                    <div className="text-danger">
                                      {errors.cPassword}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div class="row mt_20">
                              <div class="col-md-6 form_Content">
                                <div className="form-group position-relative">
                                  <label htmlFor="confirmPassword">
                                    Confirm Password
                                  </label>
                                  <input
                                    type={
                                      showConfirmPassword ? "text" : "password"
                                    }
                                    className={`form-control ${
                                      errors.confirmPassword ? "is-invalid" : ""
                                    }`}
                                    value={confirmPassword}
                                    onChange={(e) => {
                                      setConfirmPassword(e.target.value);
                                      setErrors((prev) => ({
                                        ...prev,
                                        confirmPassword: "",
                                      }));
                                    }}
                                    placeholder="Confirm Password"
                                  />
                                  <span
                                    onClick={() =>
                                      setShowConfirmPassword((prev) => !prev)
                                    }
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "38px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {showConfirmPassword ? (
                                      <FaEye size={20} />
                                    ) : (
                                      <FaEyeSlash size={20} />
                                    )}
                                  </span>
                                  {errors.confirmPassword && (
                                    <div className="text-danger">
                                      {errors.confirmPassword}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div class="col-md-6 form_Content">
                                {/* <div class="form-group ">
                                  <label for="inputName" id="namelabel12">
                                    Account Status*
                                  </label>
                                  <div class="form-group">
                                  <select
                    className="form-control"
                    value={accountStatus}
                    onChange={(e) => setAccountStatus(e.target.value)}
                  >
                    <option value="">Select Account Status</option>
                    <option value="inactive">INACTIVE</option>
                    <option value="active">ACTIVE</option>

                  </select>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Next and Previous buttons */}
                      <div className="navigation">
                        {index === 2 ? (
                          <button
                            type="button"
                            className="btn submitFormBtn"
                            onClick={handleSubmit}
                          >
                            Save
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn submitFormBtn"
                            onClick={handleNext}
                            disabled={currentStep === totalSteps}
                          >
                            Next
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn submitFormBtn"
                          onClick={handlePrevious}
                          disabled={currentStep === 1}
                        >
                          Previous
                        </button>
                      </div>
                    </fieldset>
                  ))}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
      <AlertModal
        isOpen={isAlertOpen}
        onClose={() => setIsAlertOpen(false)}
        message={alertMessage}
      />
    </div>
  );
}
